module.exports = __webpack_public_path__ + "static/media/sp1.4048d84f.png";